import { render, staticRenderFns } from "./changeOwnership.vue?vue&type=template&id=1914d169"
import script from "./changeOwnership.ts?vue&type=script&lang=js&external"
export * from "./changeOwnership.ts?vue&type=script&lang=js&external"
import style0 from "./changeOwnership.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports